import { Router, } from '@angular/router';
import { Auth } from '@freelancer/auth';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../../@freelancer/auth/auth.service";
import * as i2 from "@angular/router";
var ShellGuard = /** @class */ (function () {
    function ShellGuard(auth, router) {
        this.auth = auth;
        this.router = router;
    }
    ShellGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        var shouldBeLoggedIn = route.data.loggedIn;
        return this.auth.isLoggedIn().pipe(map(function (isLoggedIn) {
            if (isLoggedIn !== shouldBeLoggedIn &&
                route.parent &&
                route.parent.routeConfig &&
                route.parent.routeConfig.children) {
                // HACK: reverse the route config so the other route goes first
                // https://github.com/angular/angular/issues/16211
                route.parent.routeConfig.children.reverse();
                // then reload this route to access the reversed config
                // HACK 2: force the page to reload because we're doing a same url navigation
                _this.router.onSameUrlNavigation = 'reload';
                // tslint:disable-next-line:no-navigate-by-url
                _this.router.navigateByUrl(state.url).then(function () {
                    _this.router.onSameUrlNavigation = 'ignore';
                });
            }
            return isLoggedIn === shouldBeLoggedIn;
        }));
    };
    ShellGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ShellGuard_Factory() { return new ShellGuard(i0.ɵɵinject(i1.Auth), i0.ɵɵinject(i2.Router)); }, token: ShellGuard, providedIn: "root" });
    return ShellGuard;
}());
export { ShellGuard };
